/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { KeyList, Key, OauthToken, ApiKey } from "../../data/interfaces";

export const CREATE_APIKEY_FAILURE = 'CREATE_APIKEY_FAILURE';
export const CREATE_APIKEY_REQUEST = 'CREATE_APIKEY_REQUEST';
export const CREATE_APIKEY_SUCCESS = 'CREATE_APIKEY_SUCCESS';

export const FETCH_KEYS_REQUEST = 'FETCH_KEYS_REQUEST';
export const FETCH_KEYS_SUCCESS = 'FETCH_KEYS_SUCCESS';
export const FETCH_KEYS_FAILURE = 'FETCH_KEYS_FAILURE';

export const CREATE_KEYS_REQUEST = 'CREATE_KEYS_REQUEST';
export const CREATE_KEYS_SUCCESS = 'CREATE_KEYS_SUCCESS';
export const CREATE_KEYS_FAILURE = 'CREATE_KEYS_FAILURE';

export const UPDATE_KEYS_REQUEST = 'UPDATE_KEYS_REQUEST';
export const UPDATE_KEYS_SUCCESS = 'UPDATE_KEYS_SUCCESS';
export const UPDATE_KEYS_FAILURE = 'UPDATE_KEYS_FAILURE';

export const CREATE_OAUTH_TOKEN_REQUEST = 'CREATE_OAUTH_TOKEN_REQUEST';
export const CREATE_OAUTH_TOKEN_SUCCESS = 'CREATE_OAUTH_TOKEN_SUCCESS';
export const CREATE_OAUTH_TOKEN_FAILURE = 'CREATE_OAUTH_TOKEN_FAILURE';

export const MAP_APPLICATION_KEY_FAILURE = 'MAP_APPLICATION_KEY_FAILURE';
export const MAP_APPLICATION_KEY_REQUEST = 'MAP_APPLICATION_KEY_REQUEST';
export const MAP_APPLICATION_KEY_SUCCESS = 'MAP_APPLICATION_KEY_SUCCESS';

export const CREATE_API_TEST_KEY_REQUEST = 'CREATE_API_TEST_KEY_REQUEST';
export const CREATE_API_TEST_KEY_SUCCESS = 'CREATE_API_TEST_KEY_SUCCESS';
export const CREATE_API_TEST_KEY_FAILURE = 'CREATE_API_TEST_KEY_FAILURE';

export interface AppKeysAction {
    type: typeof FETCH_KEYS_REQUEST | typeof FETCH_KEYS_SUCCESS | typeof FETCH_KEYS_FAILURE
    payload?: KeyList | string
}

export interface CreateAppKeysAction {
    type: typeof CREATE_KEYS_REQUEST | typeof CREATE_KEYS_SUCCESS | typeof CREATE_KEYS_FAILURE
    payload?: Key | string
}

export interface UpdateAppKeysAction {
    type: typeof UPDATE_KEYS_REQUEST | typeof UPDATE_KEYS_SUCCESS | typeof UPDATE_KEYS_FAILURE
    payload?: Key | string
}

export interface CreateOauthTokenAction {
    type: typeof CREATE_OAUTH_TOKEN_REQUEST | typeof CREATE_OAUTH_TOKEN_SUCCESS | typeof CREATE_OAUTH_TOKEN_FAILURE
    payload?: OauthToken | string
}

export interface CreateApiKeyAction {
    type: typeof CREATE_APIKEY_REQUEST | typeof CREATE_APIKEY_SUCCESS | typeof CREATE_APIKEY_FAILURE
    payload?: ApiKey | string
}

export interface CreateApiTestKeyAction {
    type: typeof CREATE_API_TEST_KEY_REQUEST | typeof CREATE_API_TEST_KEY_SUCCESS | typeof CREATE_API_TEST_KEY_FAILURE
    payload?: ApiKey | string
}

export interface ApplicationKeyMappingAction {
    type: typeof MAP_APPLICATION_KEY_REQUEST | typeof MAP_APPLICATION_KEY_SUCCESS | typeof MAP_APPLICATION_KEY_FAILURE
    payload?: Key | string
}
